import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import print from "assets/img/icons/Print Message-01.svg";
import chat from "assets/img/icons/Chat.png";
import trash from "assets/img/icons/Trash-01 (1).svg";
import archive from "assets/img/icons/Archive-01 (1).svg";
import { useSelector, useDispatch } from "react-redux";
import {
  MessageDetailsAction,
  MessageArchiveAction,
  MessageDeleteAction,
  MessageInboxAction,
} from "../../Redux/Inbound/actions";
import moment from "moment";
import "../../assets/css/Loaders/InboundActivities.css";

export default function Activities({ id }) {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.inboundReducer?.MessageDetails);
  const [loader, setLoader] = useState(false);
  const user = useSelector((state) => state.authReducer?.data);

  useEffect(() => {
    async function fetchData() {
      if (id) {
        setLoader(true);
        await MessageDetailsAction(dispatch, id, user?.accountID);
        setLoader(false);
      }
    }
    fetchData();
  }, [id]);

  const handlePrint = () => {
    let formattedDateTime = moment(data?.createdAt).format(
      "YYYY-MM-DD HH:mm:ss A",
    );
    const printWindow = window.open("", "_blank");
    const content = `
    <html>
    <head>
      <title>Message Details</title>
      <style>
        body {
            font-family: 'Arial', sans-serif;
        }
        li {
            background-color: #ffffff;
            padding: 20px;
            margin-bottom: 20px; /* Added space at the bottom of each line */
            list-style-type: none;
        }
        hr {
            border-top: 1px solid #ddd;
            margin-top: 20px;
            margin-bottom: 20px;
        }
        strong {
            color: #172e52;
            margin-bottom:12px;
            font-size:18px;
        }
      </style>
    </head>
    <body>
      <ul>
        <li>
          ${Object?.entries(data?.messageData)
            .filter(([key, value]) => key !== "id")
            .map(
              ([key, value]) => `
              <div key="${key}" class='mt-2 mb-3'>
                <div class='mb-1'>
                  <strong class='message-p-tag'>${
                    key.charAt(0).toUpperCase() + key.slice(1)
                  }:</strong><br>
                  <p style="margin: 8px;"></p>
                  <p >${value}</p>
                  <p style="margin: 12px;"></p>
                </div>
              `,
            )
            .join("")}
              
              <strong>Answered By:</strong><br />
              <p>${data?.answeredBy}</p>
              <p style="margin: 8px;"></p>
              <strong>Call To:</strong> <br />
              <p>${data?.callTo}</p>
              <p style="margin: 8px;"></p>
              <strong>Caller Number:</strong><br />
              <p>${data?.callerNumber}</p>
              <p style="margin: 8px;"></p>
              <strong>Date:</strong> <br />
              <p>${formattedDateTime}</p>
              <p style="margin: 8px;"></p>
            </li>
        </ul>
      </body>
      </html>
  `;

    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.print();
  };

  const handleArchive = async () => {
    await MessageArchiveAction(dispatch, id,data?.accountID);
  };

  const handleInbox = async () => {
    await MessageInboxAction(dispatch, id,data?.accountID);
  };

  const handleDelete = async () => {
     await MessageDeleteAction(dispatch, id,data?.accountID);
  };
  // const handleInbox = async () => {
  // }
  return (
    <>
      {loader ? (
          <>
            <div className="loader-allActivities">
              <div className="wrapper">
                <div className="line-1"></div>
                <div className="line-2"></div>
                <div className="line-3"></div>
                <div className="line-4"></div>
                <div className="line-5"></div>
                <div className="line-6"></div>
                <div className="line-7"></div>
                <div className="line-8"></div>
                <div className="line-9"></div>
                <div className="line-10"></div>
                <div className="line-11 "></div>
                <div className="line-12 "></div>
              </div>
            </div>
          </>
      ) : data && Object.keys(data).length !== 0 ? (
          <div className="mt-5 p-0" style={{ height: "80%" }}>
            <p className="message-p-tag-large">All Activities</p>
            <>
              <Container
                style={{ overflowY: "auto", height: "65%" }}
                className=" mt-4 pl-0 d-flex align-items-center justify-content-center"
              >
                <Row className="mt-5 ml-0">
                  <Col className="d-flex flex-column p-0 ">
                    <p>ID={id}</p>
                    <h5 className="custom-color-grey">No Activity Yet</h5>
                  </Col>
                </Row>

                {/* <div>
              <Row className='mt-3 d-flex ml-0'>
                <Col md={5} className='p-0 text-center' ><p className='date-small'>From {data.date1}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>From {data.date2}</p></Col>
              </Row>
              <Row className='d-flex '>
                <Col md={5} className='p-0 text-center'><p className='date-small'>From {data.answerBy}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>From {data.answerDate}</p></Col>
              </Row>
              <Row className='mt-4'>
                <Col className='d-flex justify-content-between p-0'>
                  <p className='message-p-tag m-0'>Call Type</p>
                  <span className='call-type ml-3'>{data.callType}</span>
                </Col>
              </Row>
              <Row className='mt-3 d-flex '>
                <Col md={5} className='p-0 text-center' ><p className='date-small'>From {data.date1}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>From {data.date2}</p></Col>
              </Row>
              <Row className='d-flex '>
                <Col md={5} className='p-0 text-center'><p className='date-small'>From {data.answerBy}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>From {data.answerDate}</p></Col>
              </Row>
              <Row className='mt-4'>
                <Col className='d-flex justify-content-between p-0'>
                  <p className='message-p-tag m-0'>Call Type</p>
                  <span className='call-type ml-3'>{data.callType}</span>
                </Col>
              </Row>
              <Row className='mt-3 d-flex '>
                <Col md={5} className='p-0 text-center' ><p className='date-small'>From {data.date1}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>From {data.date2}</p></Col>
              </Row>
              <Row className='d-flex '>
                <Col md={5} className='p-0 text-center'><p className='date-small'>From {data.answerBy}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>From {data.answerDate}</p></Col>
              </Row>
              <Row className='mt-4'>
                <Col className='d-flex justify-content-between p-0'>
                  <p className='message-p-tag m-0'>Call Type</p>
                  <span className='call-type ml-3'>{data.callType}</span>
                </Col>
              </Row>
              <Row className='mt-3 d-flex '>
                <Col md={5} className='p-0 text-center' ><p className='date-small'>From {data.date1}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>From {data.date2}</p></Col>
              </Row>
              <Row className='d-flex '>
                <Col md={5} className='p-0 text-center'><p className='date-small'>From {data.answerBy}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>From {data.answerDate}</p></Col>
              </Row>
              <Row className='mt-4 mb-4'>
                <Col className='d-flex justify-content-between p-0'>
                  <p className='message-p-tag m-0'>Call Type</p>
                  <span className='call-type ml-3'>{data.callType}</span>
                </Col>
              </Row>
            </div>  */}
              </Container>
              <Row className="d-flex flex-column ml-0">
                <p className="message-p-tag-large">More</p>
                <Col>
                  <p className="activities-p-tag mt-3 pl-0">
                    <img src={chat} alt="chat" width={20} className="mr-1" />
                    Give feedback
                  </p>
                </Col>
                <Col>
                  <p
                    className="activities-p-tag mt-1 pl-0"
                    onClick={handlePrint}
                  >
                    <img src={print} alt="print" width={20} className="mr-1" />
                    Print message
                  </p>
                </Col>
                {data?.isArchived || data?.isDeleted ?
                    <Col>
                  <p
                      className="activities-p-tag mt-1  pl-0"
                      onClick={handleInbox}
                  >
                    <img
                        src={archive}
                        width={18}
                        alt="archive"
                        className="mr-1"
                    />
                    Move to Inbox
                  </p>
                </Col>
                    :''}
                {data?.isArchived ? (
                  ""
                ) : (
                  <Col>
                    <p
                      className="activities-p-tag mt-1  pl-0"
                      onClick={handleArchive}
                    >
                      <img
                        src={archive}
                        width={18}
                        alt="archive"
                        className="mr-1"
                      />
                      Move to Archive
                    </p>
                  </Col>
                )}
                {data?.isDeleted ? (
                  ""
                ) : (
                  <Col>
                    <p
                      className="activities-p-tag mt-1  pl-0"
                      onClick={handleDelete}
                    >
                      <img
                        src={trash}
                        width={18}
                        alt="trash"
                        className="mr-1"
                      />
                      Move to trash
                    </p>
                  </Col>

                )}
                {/* {data?.isArchived || data.isDeleted ?
                <Col>
                  <p className='activities-p-tag mt-1 pl-0' onClick={handleInbox}><img src={print} alt='print' width={20} className='mr-1' />Move to inbox</p>
                </Col>:""} */}
              </Row>
              {/* <Row>

            <Col md={8}>
            <p className='custom-style-addShare p-1'  ><img src={share} alt="share" width={18} className='mr-1' /> Share</p>

            </Col>
          </Row> */}
            </>
          </div>
      ) : (
        <div className="d-flex h-75 justify-content-center align-items-center">
          <h5 className="custom-color-grey">Nothing to show</h5>
        </div>
      )}
    </>
  );
}
